import { useActiveUser } from "shared/hooks/api";
import type { UserProfile } from "shared/interfaces/api/auth";

export interface Vero1Viewer {
  canViewInternal: boolean;
  canAuthor: boolean;
}

export const deriveVero1Viewer = (
  activeUser: Pick<UserProfile, "isInternal" | "isVero1Agent"> | undefined
): Vero1Viewer => {
  const canViewInternal = Boolean(activeUser?.isInternal);
  return {
    canViewInternal,
    canAuthor: canViewInternal && Boolean(activeUser?.isVero1Agent),
  };
};

export const useVero1Viewer = (): Vero1Viewer => {
  const { activeUser } = useActiveUser();
  return deriveVero1Viewer(activeUser);
};
